import { Flex, Button, Img, Text } from "@chakra-ui/react";
import { useRef } from "react";
import { CgAdd, CgPen, CgTrash } from "react-icons/cg";

const ImagePicker = ({ edit, image, setImage, nextStep, prevStep, setRawImage }) => {
  const imageRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          console.log(reader.result);
          setImage(reader.result);
          setRawImage(file);
        }
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <Flex minH="300px" justifyContent="center" alignItems="center">
      <input
        ref={imageRef}
        type="file"
        style={{ display: "none" }}
        onChange={handleImageChange}
      />
      {image && (
        <Flex
          w="100%"
          justifyContent="center"
          alignItems="center"
          pb="30px"
          position="relative"
          flexDir="column"
        >
          <Img
            src={image}
            alt="product"
            style={{
              width: "80%",
              height: "80%",
              objectFit: "cover",
            }}
          />
          <Button
            onClick={() => {
              if(edit) {
                imageRef.current.click();
                return;
              };
              setImage(null);
              setRawImage(null);
            }}
            style={{
              position: "absolute",
              top: "0",
              right: "0",
            }}
          >
            {
              edit ? <CgPen /> : <CgTrash />
            }
          </Button>

          <Flex 
            w='100%'
            justifyContent='space-between'
            mt='20px'
            >
            <Button variant='ghost' onClick={prevStep}>
                <Text color='gray.500'>
                    Anterior
                </Text>
            </Button>
            <Button onClick={nextStep}>Siguiente</Button>

          </Flex>
        </Flex>
      )}
      {!image && (
        <Button leftIcon={<CgAdd />} onClick={() => imageRef.current.click()}>
          Agregar Imagen
        </Button>
      )}
    </Flex>
  );
};

export default ImagePicker;
